import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  isDniFeatureEnabled,
  isDniRegisteredFeatureEnabled
} from '@/config/featureFlags';
import { useGetCartTotals } from '@/modules/perseo-billing/hooks';
import { isDeviceKiosco } from '@/modules/perseo-billing/utils';
import { IdentificationDocumentTypes } from '@/modules/shared/types/IdentificationDocumentType';
import { useCustomerContext } from '@/sections/customer/CustomerContext';

import { ClubParis } from '../payment-section/components';

import PinpadElementWrapper from './kiosco-pinpad-payments.component';
import { OtherPaymentMethods } from './other-payments.component';
import { SavedCards } from './saved-cards.component';
import { Wallets } from './wallets.component';

export const ListOfPaymentMethods = () => {
  const billing = useAppSelector((state) => state?.billing);
  const shippingAddress = useAppSelector(
    (state) => state?.cart?.data?.shippingAddress
  );
  const {
    customer: { data: customer }
  } = useCustomerContext();
  const isRegistered = customer !== null;
  const isDniEnabled = isRegistered
    ? isDniRegisteredFeatureEnabled()
    : isDniFeatureEnabled();
  const availablePaymentMethods = billing?.availablePayments;
  const isKiosco = isDeviceKiosco();

  // For registered users, check customer.documentType; for guests, check shippingAddress.documentType
  const documentType = isRegistered
    ? customer?.documentType
    : shippingAddress?.documentType;

  const isForeignDocument =
    isDniEnabled && documentType === IdentificationDocumentTypes.DNI;

  const { otherMethods, cencosudCard } = useGetCartTotals();

  if (!availablePaymentMethods) return null;

  const wallets = availablePaymentMethods?.wallets;
  const savedCards = availablePaymentMethods?.savedCards;
  const paymentMethods = availablePaymentMethods?.paymentMethods;
  const clubParis = availablePaymentMethods?.clubParis;

  return (
    <>
      {!isForeignDocument && <Wallets wallets={wallets} />}

      {isKiosco && (
        <PinpadElementWrapper
          orderTotal={otherMethods?.amount}
          cencosudPrice={cencosudCard?.amount}
        />
      )}

      {!isKiosco && !isForeignDocument && (
        <SavedCards savedCards={savedCards} />
      )}

      {!isKiosco && (
        <OtherPaymentMethods
          paymentMethods={paymentMethods}
          isForeignDocument={isForeignDocument}
        />
      )}

      {!isKiosco && !isForeignDocument && clubParis && <ClubParis />}
    </>
  );
};
